import { Button, ComboBox, Dialog, DialogFooter, DialogType, FontWeights, getTheme, IButtonStyles, IComboBoxOption, IconButton, IIconProps, IStackProps, mergeStyleSets, MessageBar, Modal, PrimaryButton, ProgressIndicator, SelectionMode, Stack, TextField } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAttendeeRegistrationListItemSelected } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IEventItem } from '../../../../Models/Event/IEventItem';
import { IEventType } from '../../../../Models/EventTypes/IEventType';
import { IInvoiceItem } from '../../../../Models/Invoice/IInvoiceItem';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { IUserProfile } from '../../../../Models/Profile/IUserProfile';
import { AttendeeRegistrationGridList } from '../../Events/Events/AttendeeRegistrationList/AttendeeRegistrationGridList';
 
interface IAddRegistrationToInvoiceViewProps {
    item: IInvoiceItem;
    saveItems: () => void;
    close: () => void;
    isVisible: boolean;
    isReadOnly: boolean;
    propertyChanged: (key: string, value: any) => void;
    isLoading: boolean;
    statusMessage?: IStatusMessage;
    registrations: IAttendeeRegistrationListItemSelected[];
    eventTypes: IEventType[];
    events: IEventItem[];
    eventTypeSelected?: number;
    eventSelected?: number;
    textSelected?: string;
    setEventTypeSelected: (id?: number) => void;
    setEventSelected: (id?: number) => void;
    setTextSelected: (text?: string) => void;
    invoiceSelection:(registrationId: number, fieldName: string, value: boolean)=>void
    invoiceAllSelection: (selectFa: keyof IAttendeeRegistrationListItemSelected, fieldName: string, value: boolean) => void;
    profile: IUserProfile;
}


export const AddRegistrationToInvoiceView: React.FunctionComponent<IAddRegistrationToInvoiceViewProps> = (props) => {

    const [eventsOptions, setEventsOptions] = React.useState<IComboBoxOption[]>([])
    const [eventTypesOptions, setEventTypesOptions] = React.useState<IComboBoxOption[]>([])
    
    
    React.useEffect(() => {
        const o: IComboBoxOption[] = props.eventTypes.map(item => {
            return { key: item.id, text: item.name, data:item }
        });
        setEventTypesOptions(o);
    }, [props.eventTypes])

    React.useEffect(() => {
        const o: IComboBoxOption[] = props.events.map(item => {
            return { key: item.id, text: item.name, data: item }
        });
        setEventsOptions(o);
    }, [props.events])


    

    const theme = getTheme();

    const contentStyles = mergeStyleSets({
        container: {
            display: 'flex',
            flexFlow: 'column nowrap',
            alignItems: 'stretch',
        },
        header: [
            theme.fonts.xLargePlus,
            {
                flex: '1 1 auto',
                borderTop: `4px solid ${theme.palette.themePrimary}`,
                color: theme.palette.neutralPrimary,
                display: 'flex',
                alignItems: 'center',
                fontWeight: FontWeights.semibold,
                padding: '12px 12px 14px 24px',
            },
        ],
        body: {
            flex: '4 4 auto',
            padding: '0 24px 24px 24px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            },
        },
    });
    const stackProps: Partial<IStackProps> = {
        horizontal: true,
        tokens: { childrenGap: 40 },
        styles: { root: { marginBottom: 20 } },
    };
    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: theme.palette.neutralPrimary,
            marginLeft: 'auto',
            marginTop: '4px',
            marginRight: '2px',
        },
        rootHovered: {
            color: theme.palette.neutralDark,
        },
    };
    const cancelIcon: IIconProps = { iconName: 'Cancel' };
    const titleId = useId('title');

    const textChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event?.target) {
            var id = event.currentTarget.id;
            props.propertyChanged(id, newValue);
        }
    }

    return (<>{props.isVisible ?
        <Modal
            isOpen={props.isVisible}
            onDismiss={close}
            isBlocking={true}
        >
            <div className={contentStyles.header}>
                <span id={titleId}>Přidání registrace na fakturu</span>
                <IconButton
                    styles={iconButtonStyles}
                    iconProps={cancelIcon}
                    ariaLabel="Close popup modal"
                    onClick={props.close}
                />
            </div>
            <div className={contentStyles.body}>
                <Stack tokens={{ childrenGap: 10 }} styles={{ root: { paddingBottom: 20 } }}>
                    <Stack horizontal tokens={{ childrenGap: 10 }} >
                        <ComboBox key="eventType" options={eventTypesOptions} selectedKey={props.eventTypeSelected} label="Typ události" onChange={(e, o, i, v) => { props.setEventTypeSelected(o?.key as number) }} />
                        <ComboBox key="eventId" options={eventsOptions} selectedKey={props.eventTypeSelected} label="Událost" onChange={(e, o, i, v) => { props.setEventSelected(o?.key as number) }} />
                        <TextField key="name" id="name" label="Jméno" value={props.textSelected} onChange={(e, v) => props.setTextSelected(v)} />
                    </Stack>
                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                        <AttendeeRegistrationGridList
                            items={props.registrations}
                            isLoading={props.isLoading}
                            selectionMode={SelectionMode.none}
                            invoiceAllSelection={props.invoiceAllSelection}
                            invoiceSelection={props.invoiceSelection}
                            profile={props.profile}
                        />
                    </Stack>
                </Stack>
                <Stack styles={{ root: { minHeight: 20 } }}>
                    {props.isLoading ? <ProgressIndicator /> : null}
                    {props.statusMessage ? <MessageBar messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}
                </Stack>
                <DialogFooter>
                    <PrimaryButton onClick={() => props.saveItems()} text="Uložit" />
                    <Button text="Zavřít" onClick={props.close} />
                </DialogFooter>
            </div>


        </Modal> : null
    }</>)
}
